import { Student, LocaleId } from '@/graphql/types'
import { activityAccent } from '@blakeelearning/content-loader-core'

export function getAccent(student: Student) {
  const accent = student.localeId ?? LocaleId.Au
  return activityAccent(accent === LocaleId.Ca ? LocaleId.Us : accent)
}
